import { sortBy } from 'lodash'

import { FilterField } from '@/components/UI/Filter/utils/types'
import { FilterComparison } from '@/components/UI/Filter/utils/enums'

import { LINKED_TRANSACTION_FIELD, LINKED_TRANSACTION_LABEL } from './const'
import { FILTER_OPTION_LINKED_DATA_TRANSACTIONS, FILTER_OPTION_RESOURCE } from '@/services/filters/utils/const'

import useFiltersService from '@/services/filters'

export const getLinkedDataTransactionsFilters = (additionalFields?: FilterField[]): FilterField[] => {
  const { fetchOptions } = useFiltersService()

  return sortBy(
    [
      {
        name: LINKED_TRANSACTION_FIELD.ACCESS_METHOD,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.ACCESS_METHOD],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.ACCESS_METHOD,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.ACCOUNT_NAME,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.ACCOUNT_NAME],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.ACCOUNT_NAME,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.ACCOUNT_NUMBER,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.ACCOUNT_NUMBER],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.ACCOUNT_NUMBER,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.ACCOUNT_TYPE,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.ACCOUNT_TYPE],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.ACCOUNT_TYPE,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.AMOUNT,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.AMOUNT],
        isAmount: true,
      },
      {
        name: LINKED_TRANSACTION_FIELD.CATEGORY,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.CATEGORY],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.CATEGORY,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.CONNECTOR_NAME,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.CONNECTOR_NAME],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.CUSTODIAN,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.COUNTERPARTY,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.COUNTERPARTY],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.COUNTERPARTY,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.DATE,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.DATE],
        isDate: true,
      },
      {
        name: LINKED_TRANSACTION_FIELD.OVERRIDE_DATE,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.OVERRIDE_DATE],
        isDate: true,
      },
      {
        name: LINKED_TRANSACTION_FIELD.DESCRIPTION,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.DESCRIPTION],
      },
      {
        name: LINKED_TRANSACTION_FIELD.OVERRIDE_DESCRIPTION,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.OVERRIDE_DESCRIPTION],
      },
      {
        name: LINKED_TRANSACTION_FIELD.MONTH,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.MONTH],
        isMonth: true,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.MONTH,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.QUARTER,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.QUARTER],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.QUARTER,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.SUBCATEGORY,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.SUBCATEGORY],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.SUBCATEGORY,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.TAGS,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.TAGS],
        defaultComparison: FilterComparison.CONTAINS,
        comparison: [FilterComparison.CONTAINS, FilterComparison.NOTCONTAINS],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.TAGS,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.TYPE,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.TYPE],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.TYPE,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.YEAR,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.YEAR],
        isSimple: true,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.YEAR,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELD.STATUS,
        caption: LINKED_TRANSACTION_LABEL[LINKED_TRANSACTION_FIELD.STATUS],
        defaultComparison: FilterComparison.EQ,
        comparison: [FilterComparison.EQ, FilterComparison.NOTEQ],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.STATUS,
        ),
      },
      ...(additionalFields || []),
    ],
    'caption',
  )
}
